let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6IRvr")).then(() => parcelRequire('bvgV2'));